var LZString = require('lz-string');
var ImageCompressor = require('image-compressor.js');
var pieChart = require('angular.piechart')

/**
 * Resolves the display URL for a post image.
 * - Blob URLs (http/https): used directly
 * - Legacy LZ-compressed+Base64-encoded data: decoded to data URL
 * - Empty/null: returns empty string
 */
function resolveImageUrl(image) {
    if (!image || image.length === 0) return "";
    if (image.startsWith("http")) return image;
    // Legacy: LZ-compressed + Base64-encoded data URL
    try {
        return LZString.decompress(Base64.decode(image)) || "";
    } catch(e) {
        return "";
    }
}


function template(strings, ...keys) {
    return (function(...values) {
      let dict = values[values.length - 1] || {};
      let result = [strings[0]];
      keys.forEach(function(key, i) {
        let value = Number.isInteger(key) ? values[key] : dict[key];
        result.push(value, strings[i + 1]);
      });
      return result.join('');
    });
  }

function getSecondsBetweenTwoDateStamps(start, end) {
    var start = new Date(Date.parse(start));
    var end = new Date(Date.parse(end));

    return ((start.getTime() - end.getTime()) / 1000);
}

function arrayRemove(arr, value) { 
    return arr.filter(function(ele){ 
        return ele != value; 
    });
}

function removeAllValuesFromArray(arr, values) {
    for(var value of values) {
        arr = arrayRemove(arr, value);
    }
    return arr;
}

export default class ExerciseController {
    constructor($rootScope, $scope, $routeParams, $mdDialog, $location, exerciseService, exerciseHubService,
        channelsService, authenticationService, globalConstants, userService, notificationsService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$routeParams = $routeParams;
        this.$mdDialog = $mdDialog;
        this.exerciseId = this.$routeParams.id;
        this.avatar = null;
        this.message = {};
        this.messages = [];
        this.control = {};
        this.seconds = 0;
        this.minutes = 0;
        this.hours = 0;
        this.clockBase = null;
        this.isReadOnly = false;
        this.scheduledPosts = [];
        this.$scope.scheduledPostsLimit = 10;
        this.$scope.displayAllScheduledPosts = false;
        this.isStarted = false;
        this.activeTab = "p";
        this.stats = null;

        //read only summaries
        this.grammarMistakes = 0;
        this.averageResponseTime = 0;
        this.firstResponseTime = { minutes:0, seconds: 0};
        this.averageTimeBetweenResponses = { minutes:0, seconds: 0};
        this.totalPostsByTrainees = 0;


        this.sentimentData = [];
        this.pieChart = null;

        this.exerciseHubService = exerciseHubService;
        this.channelsService = channelsService;
        this.authenticationService = authenticationService;
        this.globalConstants = globalConstants;
        this.exerciseService = exerciseService;
        this.userService = userService;
        this.notificationsService = notificationsService;
        

        if($routeParams.readonly){
            this.isReadOnly = true;
            exerciseService.getExerciseSessionData($routeParams.id).then((resp) => {
                this.messages = resp.data.messages;
                this.stats = resp.data.statistics;
                this.processStatistics(resp.data);
            })
            return;
        }

        this.userService.getCurrent().then(resp => {
            this.account = resp.data;
        });

        exerciseService.get($routeParams.id).then((resp) => {
            this.exercise = resp.data;
            this.clockBase = resp.data.clockBase;
            this.channelsService.getByEventId(resp.data.eventId).then(resp => {
                this.channels = resp.data;
            });

            // CUSTOM THEME SUPPORT
            var dynamicStyles = `
                .theme-custom .highlight { 
                    color: ${this.exercise.themeAccentColour};
                }
                .theme-custom .btn {
                    background-color: ${this.exercise.themeAccentColour};
                }
                .theme-custom .posting-spinner{
                    color:${this.exercise.themeAccentColour} !important;
                }
                .theme-custom .theme-custom-name {
                    color:${this.exercise.themeAccentColour};
                }
            `;

            var existingStyles = document.getElementById('custom-theme');
            angular.element(existingStyles).remove();

            var styleElement = document.createElement('style');
            styleElement.type = 'text/css';
            styleElement.id = "custom-theme";

            styleElement.appendChild(document.createTextNode(dynamicStyles));
            document.head.appendChild(styleElement);
            //[END] CUSTOM THEME SUPPORT

        }, error => {
            $location.path("/");
        });

        this.$rootScope.$on("Exercise.Send", (event, data) => {
            this.messages.unshift(data);
            if (data.image && data.image.length > 0)
                data["imageUrl"] = resolveImageUrl(data.image);
        })

        this.$rootScope.$on("Exercise.SendUpdate", (event, data) => {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].id == data.id) {
                    this.messages.splice(i, 1);
                    break;
                }
            }
            data["imageUrl"] = resolveImageUrl(data.image);
            this.messages.unshift(data);
        });

        var customEventListener = this.$rootScope.$on("Exercise.OnJoined", (event, data) => {
            this.filter = new (class Filter {
                constructor() {
                    this.tag = ""
                    this.avatar = null
                    this.textSearch = ""
                }
                
                filterEnabled() {
                    return this.tag.length > 0 ||
                        this.avatar != null ||
                        this.textSearch.length >= 2;
                }
            });
            this.messages = data.messages;
            this.isStarted = data.isStarted;
            this.startTime = data.startTime;
            this.trendingTags = data.hashTagsTrending;
            this.scheduledPosts = data.scheduledPosts;
            this.hours = Math.floor(data.elapsedMinutes / 60);
            this.minutes = data.elapsedMinutes % 60;
            this.seconds = data.elapsedSeconds % 60;
            if (data.isStarted) {
                if (data.pauseTimes.length == 1) {
                    if (data.pauseTimes[0].pauseTime == null) {
                        var dateDiffMs = Math.abs(new Date() - new Date(this.startTime));
                        var secs = Math.floor(dateDiffMs / 1000);
                        this.minutes = Math.floor(secs / 60) % 60;
                        this.seconds = secs % 60;
                        this.hours = Math.floor(((dateDiffMs / 1000) / 60) / 60);
                        this.control.start();
                    }
                }
                else if (data.pauseTimes.length > 1) {
                    var latestIndex = data.pauseTimes.length - 1;
                    if (data.pauseTimes[latestIndex].pauseTime == null) {
                        var dateDiffMs = Math.abs(new Date() - new Date(data.pauseTimes[latestIndex].resumeTime));
                        for (var i = 0; i < data.pauseTimes.length; i++) {
                            if (data.pauseTimes[i].pauseTime != null && data.pauseTimes[i].resumeTime != null) {
                                dateDiffMs += Math.abs(new Date(data.pauseTimes[i].pauseTime) - new Date(data.pauseTimes[i].resumeTime));
                            }
                        }

                        var secs = Math.floor(dateDiffMs / 1000);
                        this.minutes = Math.floor(secs / 60) % 60;
                        this.seconds = secs % 60;
                        this.hours = Math.floor(((dateDiffMs / 1000) / 60) / 60);
                        this.control.start();


                    }
                }
            }else{
                this.control.refresh();
            }

            for (var message of this.messages) {

                //this.dynamicTextBoxHeight = { height: $event.target.scrollHeight + "px"};
                
                // if(message.tweet.length > 140)68
                // {
                //     message.showMoreButton = true;
                // }
                // else
                // {
                //     message.showMoreButton = false;
                // }
                
                if (message.image && message.image.length > 0)
                    message["imageUrl"] = resolveImageUrl(message.image);
            }
        });


                    
        $scope.$on('$destroy', function() {
            customEventListener();
        });

        this.$rootScope.$on("Exercise.OnPostUpdated", (event, data) => {
            if(data.inReplyToId > 0) {
                for (var i = 0; i < this.messages.length; i++) {
                    if (this.messages[i].id == data.inReplyToId){
                        for(var k = 0; k < this.messages[i].replies.length; k++) {
                            if(this.messages[i].replies[k].id == data.id) {
                                this.messages[i].replies[k] = data;
                            }
                        }
                    }
                }
            } else {
                for (var i = 0; i < this.messages.length; i++) {
                    if (this.messages[i].id == data.id)
                        this.messages[i] = data;
                }
            }
            data["imageUrl"] = resolveImageUrl(data.image);
        });

        this.$rootScope.$on("$routeChangeStart", event => {
            exerciseHubService.disconnect();
        });

        this.$rootScope.$on("Exercise.OnPostDeleted", (event, data) => {
            if (data.parentPostId) { // delete reply
                let msg = this.messages.find(x => x.id == data.parentPostId);
                if(msg) {
                    let idx = msg.replies.findIndex(x => x.id == data.postId);
                    if(idx !== -1) {
                        msg.replies.splice(idx, 1);
                    }
                }
            }
            else 
            {
                this.messages.splice(this.messages.findIndex(x => x.id == data.postId), 1);
            }
        });

        this.exerciseHubService.join(this.exerciseId);
        
        this.$rootScope.$on("Exercise.OnExerciseStateChange", (event, data) => {
            this.isStarted = data.isStarted;
            this.startTime = data.startTime;
            if (this.isStarted) {
                this.control.start()
            }
            else if (!this.isStarted) {
                this.control.stop()
            }
        });

        this.$rootScope.$on("Exercise.TrendingUpdate", (event, data) => {
            this.trendingTags = data;
        });

        // this.$rootScope.$on("Exercise.OnScheduledPostsChanged", (event, data) => {
        //     this.scheduledPosts = data;
        // });

        this.$rootScope.$on("Exercise.OnExerciseStopped", (event, data) => {
            $location.path('/');
        });
    }

    showAllScheduledPosts() {
        this.$scope.displayAllScheduledPosts = true;
    }

    filterByTag(tag) {
        this.filter.tag = tag;
    }

    deleteScheduledPost(sp) {
        if(confirm("Are you sure you want to delete this scheduled post?")) {
            this.exerciseHubService.deleteScheduledPost(this.exerciseId, sp.id);
        }
    }

    filterByProfile(avatar) {
        this.filter.avatar = avatar;
    }

    removeFilterByTag() {
        this.filter.tag = "";
    }

    removeFilterByProfile() {
        this.filter.avatar = null;
    }

    filterPostByFilter(filter) {
        return function (message) {
            function test(message) {
                if(filter.avatar != null 
                    && 
                    (
                        (message.avatar == null || message.avatar.id != filter.avatar.id) 
                        && message.userDetail.userId != filter.avatar.userId
                    )) {
                    return false;
                }
                
                if(filter.tag.length > 0 && message.tweet.toLowerCase().indexOf(filter.tag.toLowerCase()) < 0) {
                    return false;
                }

                if(filter.textSearch.length >= 2) {

                    var av=message.avatar ? message.avatar : {};
                    var ud= !message.avatar && message.userDetail ? message.userDetail : { };

                    var payload = [message.tweet, av.userHandle, av.name, ud.userHandle, ud.userName].join(" ").toLowerCase();
                    var search = filter.textSearch.toLowerCase();
                    if(payload.indexOf(search) < 0){
                        return false;
                    }
                }



                return true;
            }


            try {

                if(message.type !== 'p') { // only show 'published' "tweets"
                    return false;
                }

                if(test(message))
                    return true;
                
                for(var reply of message.replies) {
                    if(test(reply)) {
                        return true;
                    }
                }

                if(filter.filterEnabled())
                    return false;

            } catch (ex){
                console.log("Search error: "+ex);
            } 

            return true;
        }
    }

    draftsFilter(message) {
        return message.type === 'd';
    }

    scheduledFilter(message) {
        return message.type === 's';
    }

    toggleExerciseState() {
        if(!this.isStarted) { //if exercise is off
            this.exerciseService.startExercise(this.exerciseId).then(response => {
                this.exerciseHubService.toggleExerciseState(this.exerciseId);
            }, response => {
                this.notificationsService.show("Course credit limit exceeded", "error");
            })
        }
        else {
            this.exerciseHubService.toggleExerciseState(this.exerciseId);
        }
    }

    reset(ev) {
        this.exerciseHubService.reset(this.exerciseId);
        this.hideWarning(ev);
    }

    endExercise(ev) {
        this.exerciseService.endExercise(this.exerciseId).then(response => {
            this.exerciseHubService.endExercise(this.exerciseId);
            this.exercise.ExerciseStopped = true;
            this.hideWarning(ev);
            window.location.href = "/";
        });
    }

    showWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#endExerciseDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#endExerciseDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    showResetWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#resetExerciseDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideResetWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#resetExerciseDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };
    likePost(post, parentPost) {
        if (this.hasLikedPost(post))
            return;

        var model = {
            exerciseId: post.exerciseId,
            postId: post.id,
            parentId: typeof(parentPost) != 'undefined' ? parentPost.id : 0,
            userId: this.account.id
        };

        this.exerciseHubService.likePost(model);
    }

    sharePost(post, parentPost) {
        if (this.hasSharedPost(post))
            return;

        var model = {
            exerciseId: post.exerciseId,
            postId: post.id,
            parentId: typeof(parentPost) != 'undefined' ? parentPost.id : 0,
            userId: this.account.id
        };

        this.exerciseHubService.sharePost(model);
    }

    retweetPost(post) {
        this.message.retweetPost = post;
    }

    replyToPost(post, parentPost) {
        this.message.tweet = `\@${post.avatar != null ? post.avatar.userHandle : post.userDetail.userHandle} `;

        //if (parentPost) {
        //    this.message.tweet = ` \@${parentPost.avatar != null ? parentPost.avatar.userHandle : parentPost.userDetail.userHandle} `;
        //}

        this.message["inReplyToId"] = parentPost ? parentPost.id : post.id;

        var messageElement = document.getElementById('message');
        messageElement.focus();
        setTimeout(() => {
            this.setCaretPosition(messageElement, this.message.tweet.length)
        }, 200)

    }

    hasLikedPost(post) {
        for (var like of post.likes) {
            if (like == this.account.id)
                return true;
        }
        return false;
    }

    hasSharedPost(post) {
        for (var share of post.shares) {
            if (share == this.account.id)
                return true;
        }
        return false;
    }

    deletePost(post, parentPost) {
        this.exerciseHubService.deletePost(this.exerciseId, post, parentPost);
    }

    sendDraftNow(post) {
        this.exerciseHubService.sendDraft(this.exerciseId, post.id, false);
        this.notificationsService.show("Draft has been sent", "success");
    }

    sendDraftCopyNow(post) {
        this.exerciseHubService.sendDraft(this.exerciseId, post.id, true);
        this.notificationsService.show("Copy of the draft has been sent", "success");
    }
    
    scheduleDraft(post) {
        var delayInMinutes = Number(window.prompt("How many minutes into the exercise do you wish to post this draft?"));
        if(Number.isInteger(delayInMinutes)){
            this.exerciseHubService.scheduleDraft(this.exerciseId, post.id, delayInMinutes);
            this.notificationsService.show(`Draft has been scheduled to post in ${delayInMinutes} minute${(delayInMinutes==1?"":"s")}`, "success");
        }else{
            this.notificationsService.show("Please enter a whole number", "error");
        }
    }

    display_timeSince(date) {
        if (typeof (date) == "string")
            date = Date.parse(date);
        var seconds = Math.floor((new Date() - date) / 1000);

        var interval = Math.floor(seconds / 31536000);

        if (interval > 1) {
            return interval + " years ago";
        }
        interval = Math.floor(seconds / 2592000);
        if (interval > 1) {
            return interval + " months ago";
        }
        interval = Math.floor(seconds / 86400);
        if (interval > 1) {
            return interval + " days ago";
        }
        interval = Math.floor(seconds / 3600);
        if (interval > 1) {
            return interval + " hours ago";
        }
        interval = Math.floor(seconds / 60);
        if (interval > 1) {
            return interval + ` minute${Math.floor(interval) > 1 ? 's' : ''} ago`;
        }
        return "Just Now";
    }

    setCaretPosition(el, pos) {

        // Loop through all child nodes
        for (var node of el.childNodes) {
            if (node.nodeType == 3) { // we have a text node
                if (node.length >= pos) {
                    // finally add our range
                    var range = document.createRange(),
                        sel = window.getSelection();
                    range.setStart(node, pos);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                    return -1; // we are done
                } else {
                    pos -= node.length;
                }
            } else {
                pos = this.setCaretPosition(node, pos);
                if (pos == -1) {
                    return -1; // no need to finish the for loop
                }
            }
        }
        return pos; // needed because of recursion stuff
    }

    processStatistics(model) { 
        this.totalPosts = model.messages.length; 
        this.trendingTags = model.hashTagsTrending;

        if(model.statistics) {
            this.sentimentData = [
                { label: 'Positive', count: model.statistics.positiveCount, color: '#4caf50', cssClass: 'positive' },
                { label: 'Negative', count: model.statistics.negativeCount, color: '#f44336', cssClass: 'negative' },
                { label: 'Neutral',  count: model.statistics.neutralCount,  color: '#9e9e9e', cssClass: 'neutral' },
                { label: 'Unknown',  count: model.statistics.unknownCount,  color: '#ff9800', cssClass: 'unknown' }
            ];
            this.renderSentimentChart();
        }
    }

    getPercentage(index) {
        const total = this.pieChartData.reduce(function(a, b) { return a + b; }, 0);
        if (!total) return 0;
        return (this.pieChartData[index] / total) * 100;
    };

    renderSentimentChart() {
        const canvas = document.getElementById('sentimentPieChart');
        if (!canvas) return;

        const ctx = canvas.getContext('2d');

        if (this.pieChart) {
            this.pieChart.destroy();
        }

        const labels = this.sentimentData.map(item => item.label);
        const data = this.sentimentData.map(item => item.count);
        const colors = this.sentimentData.map(item => item.color);

        this.pieChart = new Chart(ctx, {
            type: 'pie',
            data: {
            labels: labels,
            datasets: [{
                data: data,
                backgroundColor: colors,
                borderColor: '#ffffff',
                borderWidth: 2
            }]
            },
            options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            tooltips: {
                callbacks: {
                label: function (tooltipItem, data) {
                    const index = tooltipItem.index;
                    const label = data.labels[index];
                    const value = data.datasets[0].data[index];
                    const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
                    const pct = total ? ((value / total) * 100).toFixed(1) : 0;
                    return `${label}: ${value} (${pct}%)`;
                }
                }
            }
            }
        });
    };

}



// WEBPACK FOOTER //
// ./src/js/components/exercise/exercise.controller.js